import React, { useEffect, useState } from "react";
import { Spinner } from "@fluentui/react-components";
import { ENTITY_CANDIDATE, ENTITY_CONSULTANT, ENTITY_RELATION, ENTITY_RELATION_CONTACT } from "../utils/Constants";
import { useMessage } from "../blocks/message/MessageContext";
import { getSenderEmailAddress } from "../utils/OfficeApiHelper";
import EntitySelectionPage from "./EntitySelectionPage";
import EntityCreationPage from "./EntityCreationPage";
import Ows from "../utils/OwsHandler";

const EntityHandlerPage = () => {
  const { showMessage } = useMessage();
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSenderEmailAddress((email) => {
      if (email) {
        (async () => {
          try {
            const data = await Ows.handleRequest("Otys.Services.EntityLookUpService.getUidByEmail", [
              email,
            ]);
  
            if (data.error) {
              throw new Error(data.error.message);
            }
  
            const { Consultant, Candidate, Relation, RelationContact } = data.response;

            const foundEntities = [
              Consultant && { name: ENTITY_CONSULTANT, uid: Consultant.uid },
              Candidate && { name: ENTITY_CANDIDATE, uid: Candidate.uid },
              Relation && { name: ENTITY_RELATION, uid: Relation.uid },
              RelationContact && { name: ENTITY_RELATION_CONTACT, uid: RelationContact.uid },
            ].filter(Boolean);
  
            setEntities(foundEntities);
          } catch (error) {
            console.error(error);
          } finally {
            setLoading(false);
          }
        })();
      } else {
        setLoading(false);
        showMessage("error", "Failed to get sender email address.");
      }
    });
    
  }, []);

  if (loading) {
    return <Spinner label="Getting things ready..." labelPosition="above" style={{marginTop: "20px"}} />;
  }

  return entities.length > 0 ? <EntitySelectionPage entities={entities} /> : <EntityCreationPage />;
};

export default EntityHandlerPage;
